import apiClient from "api/config/apiClient";

export default {
  getVariableRemuneration(payload) {
    return apiClient.request('cache-disable/variable_remuneration', payload)
  },
}
